import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IRootState } from '../../../state-mgmt/rootState';
import ApproveUser from './ApproveUser';
import { userState } from '../../../state-mgmt/user';
import { GENERAL } from '../../../../constants';
import { generalState } from '../../../state-mgmt/general';
import { push } from 'connected-react-router';
import { UserModel } from 'modules/models';

export const mapStateToProps = (state: IRootState) => ({
  approveUserResult: state.user.approveUserResult,
  approveUserLoading: state.general.loadingMap[GENERAL.LOADING_KEY.APPROVE_USER],
  companyUserProfile: state.user.companyUserProfile,
  fetchUserLoading: state.general.loadingMap[GENERAL.LOADING_KEY.FETCH_USER_PROFILE],
  updateUserLoading: state.general.loadingMap[GENERAL.LOADING_KEY.UPDATE_USER],
  groupList: state.user.groupList,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  approveUser: (userId: string, companyId: string, projectId: string) => dispatch(userState.actions.approveUserStart(userId, companyId, projectId)),
  fetchUserProfile: (companyId: string, companyUserId: string) => dispatch(userState.actions.fetchUserProfileStart(companyId, companyUserId)),
  updateUserProfile: (companyId: string, companyUserId: string, user: UserModel.IAccount, isCurrentUserCompanyRemoved: boolean) =>
    dispatch(userState.actions.updateUserProfileStart(companyId, companyUserId, user, isCurrentUserCompanyRemoved)),
  fetchGroupSearch: (query: any) => dispatch(userState.actions.fetchGroupSearchStart(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveUser);
